// rcmNav.js — a one-shot handoff between RCM screens. The dashboard leaves a note saying which claims to show
// (facility, view and filters); the Claims page picks it up once when it opens. Nothing is stored; it lives for one click.
let intent = null;
export const setClaimsIntent = (x) => { intent = x || null; };
// read it now, clear it a moment later (so a doubled first render still sees it once)
export const takeClaimsIntent = () => { const x = intent; if (x) setTimeout(() => { if (intent === x) intent = null; }, 0); return x; };
